var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ChatsCircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.13121 8.79386C1.57081 7.84971 1.37438 6.73345 1.57882 5.65471C1.78326 4.57598 2.37451 3.609 3.24151 2.93537C4.10851 2.26175 5.19162 1.92783 6.28742 1.99633C7.38321 2.06484 8.4163 2.53105 9.19266 3.3074C9.96902 4.08376 10.4352 5.11685 10.5037 6.21265C10.5722 7.30844 10.2383 8.39155 9.56469 9.25856C8.89107 10.1256 7.92408 10.7168 6.84535 10.9212C5.76662 11.1257 4.65035 10.9293 3.70621 10.3689L2.14996 10.8126C2.08584 10.8306 2.01807 10.8313 1.95363 10.8144C1.88919 10.7976 1.83039 10.7639 1.7833 10.7168C1.7362 10.6697 1.70249 10.6109 1.68565 10.5464C1.66881 10.482 1.66943 10.4142 1.68746 10.3501L2.13121 8.79386Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.75623 10.9938C5.9765 11.6219 6.33353 12.1931 6.80151 12.6664C7.2695 13.1396 7.83675 13.5029 8.46229 13.7302C9.08784 13.9575 9.75605 14.0429 10.4186 13.9804C11.0813 13.9179 11.7217 13.709 12.2937 13.3688V13.3688L13.85 13.8126C13.9141 13.8306 13.9819 13.8312 14.0463 13.8144C14.1107 13.7976 14.1695 13.7639 14.2166 13.7168C14.2637 13.6697 14.2974 13.6109 14.3143 13.5464C14.3311 13.482 14.3305 13.4142 14.3125 13.3501L13.8687 11.7938C14.2649 11.1289 14.4826 10.3728 14.5007 9.59896C14.5188 8.82512 14.3367 8.05972 13.972 7.37694C13.6073 6.69416 13.0725 6.11715 12.4193 5.70182C11.7661 5.28649 11.0167 5.04693 10.2437 5.00635",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsCircle);
export default __webpack_public_path__ + "static/media/chats-circle.9346f9aa8e2da874f3942a25730e10dc.svg";
export { ForwardRef as ReactComponent };